import { render, staticRenderFns } from "./traceability.vue?vue&type=template&id=4cbf6e8e&scoped=true&"
import script from "./traceability.vue?vue&type=script&lang=js&"
export * from "./traceability.vue?vue&type=script&lang=js&"
import style0 from "./traceability.vue?vue&type=style&index=0&id=4cbf6e8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbf6e8e",
  null
  
)

export default component.exports